import React, { useState } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export function Tooltip({ content, children, position = 'top' }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {isVisible && (
        <div
          className={`absolute z-10 whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs text-white ${positionClasses[position]}`}
        >
          {content}
          <div
            className={`absolute ${
              position === 'top'
                ? 'left-1/2 top-full -translate-x-1/2 border-t-gray-900'
                : position === 'bottom'
                ? 'left-1/2 bottom-full -translate-x-1/2 border-b-gray-900'
                : position === 'left'
                ? 'right-0 top-1/2 -translate-y-1/2 border-l-gray-900'
                : 'left-0 top-1/2 -translate-y-1/2 border-r-gray-900'
            } border-8 border-transparent`}
          />
        </div>
      )}
      {children}
    </div>
  );
}